import { post, get,postJson,imagePost } from './axios';

// const RESOURCE_BASE_PATH = 'http://116.196.113.156/jd-yusms/smsSentRecord';
const RESOURCE_BASE_PATH = '';

/**taskType (integer, optional): 
任务类型 1付款提醒 2发货提醒 3迟发提醒 4签收提醒 5完成提醒 6取消提醒 
8催付提醒 11货到付款提醒 12二次催付提醒 13派件提醒 14签收提醒 15 首单专享礼 
16 复购有礼 17 休眠有礼 18 满月礼 19 百日礼 20 周年庆 21 会员账单 22 等级升级前提醒 
23 等级升级后提醒 24 预售尾款催付提醒
*/
//  短信记录
export const getSmsSentRecordList = p => get(`${RESOURCE_BASE_PATH}/smsSentRecord/remind-task/list`, p);

// 催付模块短信记录
export const getNotpayremindRecordList = p => get(`/notpayremind/page`, p);
/**
 * 评价短信记录
 */
export const popCommentConfig = p =>{
    return get(`${RESOURCE_BASE_PATH}/popCommentConfig/`,p)
}

/**
 * 退款关怀短信记录
 */

export const getRefundSendRecord = p =>{
    return get(`${RESOURCE_BASE_PATH}/refundReminderConfig/getRefundSendRecord`,p)
}

//  查询悦信测试短信
export const getYueTestSms = p => get(`${RESOURCE_BASE_PATH}/smsSentRecord/yeion/test`, p);

//  根据批次ID查询短信记录
export const getSmsRecord = p => get(`${RESOURCE_BASE_PATH}/smsSentRecord/batch-id/page`, p);
